import {Component, OnInit, ElementRef, Inject, OnDestroy} from '@angular/core';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

import {Data} from './class/data';
import {Model} from './class/model';
import {Schema} from './class/schema';

import {UserDataService} from './role-service/data.service';
import {UserJsPlumbService} from './role-service/jsPlumb.service';
import {CdkDragEnd} from '@angular/cdk/drag-drop';
import {environment} from '../../environments/environment';
import {setTime} from 'ngx-bootstrap/chronos/utils/date-setters';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmExclusionsDialogComponent} from '../manage-roles/manage-roles.component';
import {DeletePermissionGroupDialogComponent} from '../manage-roles/manage-roles.component';
import {AccountInfoService} from '../user/account-info.service';

declare let $;
declare let dagre;
declare let jsPlumb: any;


export interface DialogData {
    deleteAction: string;
}

export interface UsersListData {
    userGroupName: any;
    usersList: any;
}

export interface RoleDialogData {
    name: string;
    action: string;
}

@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit, OnDestroy {
    permissionGroups: any;
    permissions: any;
    roles: any;
    orgchart: any;
    error: boolean;
    items: any;
    columns: any;
    itemList: any;
    options: any;
    errorMessage: string;
    searchText: any;
    itemLength: any;
    filterData: any[];
    getRoleName: string;
    operation: string;
    settings = {text: 'Select attribute(s) to search instantly'};
    userView = 'table';
    entity = 'Manage Roles';
    create = false;
    columnCopy: any;
    rightPanel = true;
    contentLoading = true;

    data: Data;
    myModel: Model;
    modelPreview: Model;
    schema: Schema;
    pY: number;
    models = [];
    schemas = [];
    links = [];
    createdRoles = [];
    dbRoles = {};
    dbRolesWithId = {};
    excludedPermissions = [];
    userExcludedPermissionGroups = [];
    userAddedPermissionGroups = [];
    userAddedPermissions = [];
    topLevelRoles = [];
    highlightedModel: any;
    masterRole = '';
    previewPaneOpened = false;
    jsPlumbInitialized = false;
    canvasOpenable = false;
    nameInputForm = false;
    isNewRoleCreated = false;
    deleteAction: 'removeFromRole';
    currentAction = '';
    currentActionName = '';
    apiRoleSearchText: string;
    apiPermissionGroupSearchText: string;
    apiPermissionSearchText: string;
    platformRoleSearchText: string;
    createdUser: any;
    users: any;
    selectedUser: any;
    selectedEnvironment: any;
    selectedRoles: any;
    selectedExcludedPermissionGroups: any;
    selectedExcludedPermissions: any;
    selectedExcludedRoles: any;
    platformRoles: any;
    apiRoles: any;
    apiPermissionGroups: any;
    apiPermissions: any;
    usersList: any;
    entityType: any;
    myRole: any;
    position = {x: 100, y: 100};
    initialPosition = {x: 100, y: 100};
    previewBlock: any;
    offset: any;
    dragStarted = false;
    previewData: Data;
    pos1 = 0;
    pos2 = 0;
    pos3 = 0;
    pos4 = 0;

    constructor(public urlRoute: ActivatedRoute,
                public _service: ConnecttocrudService,
                public platform: LeftpanelComponent,
                public dataService: UserDataService,
                public jsPlumbService: UserJsPlumbService,
                public accountInfoService: AccountInfoService,
                private el: ElementRef,
                public dialog: MatDialog) {
        this.data = new Data();
        this.previewData = new Data();
        this.data = this.dataService.data;
        // this.jsPlumbService.init();
    }

    ngAfterViewChecked() {
        // this.populateTables();
        // this.jsPlumbService.init();
        if (this.dataService.flg_repaint) {
            this.dataService.flg_repaint = false;
            this.jsPlumbService.repaintEverything();
        }
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        // this.testBlock();
        this.error = false;
        this.urlRoute.queryParams.subscribe(params => {
            if (params.type && params.id && params.environment) {
                this.entityType = params.type;
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services,' + params.environment + '&&type=platform, account').subscribe(data => {
                    if (data) {
                        this.platformRoles = data;
                        this.platformRoles = this.platformRoles.filter((v, i) => v.role !== 'Super Admin' && !v.role.includes('services@apiplatform.io'));
                    }
                    // console.log(this.roles);
                    // this.roles = this.roles.filter((v, i) => v.role !== 'Super Admin' && !v.role.includes('services@apiplatform.io'));
                    // if (this.roles) {
                    for (const role of this.platformRoles) {
                        this.dbRoles[role.role] = role.id;
                    }
                    // }
                    // this.contentLoading = false;
                });
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=' + params.environment + '&&type=account').subscribe(data => {
                    if (data) {
                        this.apiRoles = data;
                        if (params.type === 'users') {
                            this.loadRecord(params.id, params.environment, 'users');
                        } else {
                            this.loadRecord(params.id, params.environment, 'usergroups');
                        }

                        // const filtered_roles = this.apiRoles.filter((v, i) => v.role.includes(localStorage.getItem('signInEmail')));
                        // if (filtered_roles && filtered_roles.length) {
                        //     this.myRole = filtered_roles[0].role;
                        //     console.log(this.myRole);
                        // }
                        for (const role of this.apiRoles) {
                            this.dbRoles[role.role] = role.id;
                        }
                    }
                });
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'partner.in=' + params.environment + '&&type=account').subscribe(data => {
                    if (data) {
                        this.apiPermissionGroups = data;
                    }
                });
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'partner.in=' + params.environment + '&&type=account').subscribe(data => {
                    if (data) {
                        this.apiPermissions = data;
                    }
                });
            }
        });
    }

    ngOnDestroy() {
        this.clearCanvas();
        // this.permissionGroups = [];
        // this.permissions = [];
        // this.roles = [];
    }

    loadRecord(id, env, entity) {
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, entity, 'id=' + id).subscribe(async result => {
            const res = result;
            this.selectedUser = res[0];
            this.selectedEnvironment = env;
            const environments = this.selectedUser['environments'].filter((v, i) => v.name === this.selectedEnvironment);
            if (entity === 'users') {
                const filtered_roles = this.apiRoles.filter((v, i) => v.role.includes(this.selectedUser.email));
                if (filtered_roles && filtered_roles.length) {
                    this.myRole = filtered_roles[0].role;
                }
            } else {
                const filtered_roles = this.apiRoles.filter((v, i) => v.role.includes(this.selectedUser.name));
                if (filtered_roles && filtered_roles.length) {
                    this.myRole = filtered_roles[0].role;
                }
                if (environments[0].users.length) {
                    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id.in=' + environments[0].users.join(',')).subscribe(users => {
                        this.usersList = users;
                    });
                }
            }

            //this.selectedRoles = environments[0].roles;
            //this.selectedExcludedPermissionGroups = environments[0].exclusions.permission_groups;
            //this.selectedExcludedPermissions = environments[0].exclusions.permissions;
            //console.log('id.in=' + this.selectedExcludedPermissions.join(','));
            if (environments[0].exclusions.permission_groups && environments[0].exclusions.permission_groups.length) {
                this.selectedExcludedPermissionGroups = await this.loadExcludedPermissionGroups(environments[0].exclusions.permission_groups.join(','));
            } else {
                this.selectedExcludedPermissionGroups = [];
            }
            if (environments[0].exclusions.permissions && environments[0].exclusions.permissions.length) {
                this.selectedExcludedPermissions = await this.loadExcludedPermissions(environments[0].exclusions.permissions.join(','));
            } else {
                this.selectedExcludedPermissions = [];
            }
            if (environments[0].exclusions.roles && environments[0].exclusions.roles.length) {
                this.selectedExcludedRoles = await this.loadExcludedRoles(environments[0].exclusions.roles.join(','));
            } else {
                this.selectedExcludedRoles = [];
            }
            if (environments[0].roles && environments[0].roles.length) {
                this.selectedRoles = await this.loadRoles(environments[0].roles.join(','));
            } else {
                this.selectedRoles = [];
            }
            this.contentLoading = false;
            //this.jsPlumbService.init();
            setTimeout(() => {
                this.createExistingUser(this.selectedUser);
            }, 1000);

            //this.selectedExcludedRoles = environments[0].exclusions.roles;
            //this.loadUsers();
            //this.loadPermissionGroups();
            //this.loadPermissions();
            //this.loadRoles();
        });
    }

    async loadExcludedPermissionGroups(param) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'id.in=' + param).subscribe(response => {
                resolve(response);
            });
        });
    }

    async loadExcludedPermissions(param) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'id.in=' + param).subscribe(response => {
                resolve(response);
            });
        });
    }

    async loadExcludedRoles(param) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + param).subscribe(response => {
                resolve(response);
            });
        });
    }

    async loadRoles(param) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + param).subscribe(response => {
                resolve(response);
            });
        });

        // this._service.getAllRoles().subscribe(response => {
        //     this.roles = response;
        //     for (const role of this.roles) {
        //         this.dbRoles[role.role] = role.id;
        //         this.dbRolesWithId[role.id] = role;
        //     }
        //     this.createExistingUser(this.selectedUser);
        // });
    }

    getPermissionGroup(id) {
        let result;
        this._service.getPermissionGroup(localStorage.getItem('partner'), localStorage.getItem('account'), id).subscribe(data => {
            result = data;
        });
        return result;
    }


    typeOfval(val) {
        return typeof val;
    }

    stringifyjson(val) {
        return JSON.stringify(val, null, 2).trim();
    }


    openNameInputForm(action) {
        // this.nameInputForm = true;
        // this.currentAction = action;
        // this.currentActionName = '';
        // const dialogRef = this.dialog.open(NewRoleDialogComponent, {
        //   width: '250px',
        //   data: {name: this.currentActionName, action: this.currentAction}
        // });
        //
        // dialogRef.afterClosed().subscribe(result => {
        //   this.currentActionName = result;
        // });
    }


    closeNameInputForm() {
        this.nameInputForm = false;
        if (this.currentAction === 'Role') {
            this.masterRole = this.currentActionName;
            //this.createNewRole(this.currentActionName);
            this.isNewRoleCreated = true;
            setTimeout(() => {
                this.tryArrangeBlocks(true);
            }, 1000);

        }
        if (this.currentAction === 'Permission Group') {
            this.createNewPermissionGroup(this.currentActionName);
            setTimeout(() => {
                this.tryArrangeBlocks(true);
            }, 1000);
        }
    }

    createExistingUser(user) {
        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init();
            this.jsPlumbInitialized = true;
        }
        let parent = '';
        if (this.entityType === 'users') {
            parent = user.email;
            this.masterRole = user.email;
        } else {
            parent = user.name;
            this.masterRole = user.name;
        }
        this.createdUser = user;
        this.myModel = new Model();
        this.myModel.name = parent;
        this.myModel.display_name = parent;
        this.myModel.previewBlock = false;
        this.myModel.type = 'role';
        this.myModel.belongsTo = '';
        this.myModel.parentRole = '';
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        const from = this.myModel.getElementId();

        this.myModel = new Model();
        this.myModel.name = 'Roles';
        this.myModel.display_name = 'Roles';
        this.myModel.previewBlock = false;
        this.myModel.type = parent;
        this.myModel.belongsTo = parent;
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});


        this.myModel = new Model();
        this.myModel.name = 'Exclusions';
        this.myModel.display_name = 'Exclusions';
        this.myModel.previewBlock = false;
        this.myModel.type = parent;
        this.myModel.belongsTo = parent;
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});
        const fromExclusions = this.myModel.getElementId();


        this.myModel = new Model();
        this.myModel.name = 'Permission Groups';
        this.myModel.display_name = 'Permission Groups';
        this.myModel.previewBlock = false;
        this.myModel.type = 'Exclusions';
        this.myModel.belongsTo = 'Exclusions';
        this.myModel.parentRole = parent;
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: fromExclusions, to: this.myModel.getElementId()});

        this.myModel = new Model();
        this.myModel.name = 'Permissions';
        this.myModel.display_name = 'Permissions';
        this.myModel.previewBlock = false;
        this.myModel.type = 'Exclusions';
        this.myModel.belongsTo = 'Exclusions';
        this.myModel.parentRole = parent;
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: fromExclusions, to: this.myModel.getElementId()});

        this.myModel = new Model();
        this.myModel.name = 'Roles';
        this.myModel.display_name = 'Roles';
        this.myModel.previewBlock = false;
        this.myModel.type = 'Exclusions';
        this.myModel.belongsTo = 'Exclusions';
        this.myModel.parentRole = parent;
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: fromExclusions, to: this.myModel.getElementId()});


        //for (const env of user.environments) {
        for (const role of this.selectedRoles) {
            //const userRoles = this.roles.filter((v, i) => v.id === role);
            //if (userRoles) {
            this.createExistingRole(role);
            //}
        }
        //}

        // for (const role of user.environments[0].roles) {
        //     const userRoles = this.roles.filter((v, i) => v.id === role);
        //     if (userRoles) {
        //         this.createExistingRole(userRoles[0]);
        //     }
        //     //this.createExistingRole(role);
        // }

        // setTimeout(() => {
        //     console
        // }, 2000);
        if (this.selectedExcludedRoles && this.selectedExcludedRoles.length) {
            setTimeout(() => {
                // this.arrangeBlocks();
                this.tryArrangeBlocks(true);
            }, 1000);
            setTimeout(() => {
                this.createUserExclusions();
            }, 5000);
        } else {
            this.createUserExclusions();
        }


    }


    createUserExclusions() {
        for (const permissionGroup of this.selectedExcludedPermissionGroups) {
            //const permissionGroup = this.permissionGroups.filter((v, i) => v.id === cpermissionGroup)[0];
            this.modelPreview = new Model();
            this.modelPreview.name = permissionGroup.permissionGroup;
            this.modelPreview.display_name = permissionGroup.display_name && permissionGroup.display_name !== '' ? permissionGroup.display_name : permissionGroup.permissionGroup;
            this.modelPreview.use_soft_delete = false;
            this.modelPreview.previewBlock = false;
            this.modelPreview.type = 'permissionGroup';
            this.modelPreview.belongsTo = 'Permission Groups';
            this.modelPreview.parentRole = 'Exclusions';
            this.modelPreview.dbId = permissionGroup.id;
            this.modelPreview.id = this.dataService.data.getNewModelId();
            //this.dataService.addModel(this.modelPreview);
            //this.models.push(this.modelPreview);
            // this.links.push({
            //     from: this.dataService.getModelByName('Permission Groups').getElementId(),
            //     to: this.modelPreview.getElementId()
            // });
            //count = count - 1;
            for (const permission of permissionGroup.permissions) {
                const schema = new Schema();
                schema.name = permission['permission'];
                schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
                schema.type = 'text';
                schema.input_type = 'text';
                schema.parent_id = this.modelPreview.id;
                schema.dbId = permission.id;
                this.modelPreview.schemas.push(schema);
                //this.dataService.addSchema(schema);

            }
            this.userExcludedPermissionGroups.push(permissionGroup.permissionGroup);
            this.dataService.getModelByName('Permission Groups').childModels.push(this.modelPreview);
        }

        for (const permission of this.selectedExcludedPermissions) {
            //const permission = this.permissions.filter((v, i) => v.id === cPermission)[0];
            const schema = new Schema();
            schema.name = permission.permission;
            schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
            schema.dbId = permission.id;
            schema.type = 'text';
            schema.input_type = 'text';
            schema.parent_id = this.dataService.getModelByName('Permissions').id;
            this.dataService.addSchema(schema);
            this.excludedPermissions.push(permission.permission);
        }

        for (const role of this.selectedExcludedRoles) {
            //const role = this.roles.filter((v, i) => v.id === cRole);
            this.createRoleBlock(role, 0, 0, 'Exclusions');
            // this.masterRole = this.masterRole === '' ? role.role : this.masterRole;
            // this.createRoleBlock(role);
            this.createdRoles.push(role.role);
            this.createSubRoles(role);
        }

        setTimeout(() => {
            // this.arrangeBlocks();
            this.tryArrangeBlocks(true);
        }, 1000);
    }


    createNewPermissionGroup(permissionGroupName) {
        this.myModel = new Model();
        this.myModel.name = permissionGroupName;
        this.myModel.display_name = permissionGroupName;
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = 'permissionGroup';
        this.myModel.belongsTo = '';
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
    }

    createNewRole(role, posX = 600, posY = 100, parentRole = '') {
        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init();
            this.jsPlumbInitialized = true;
        }

        this.myModel = new Model();
        this.myModel.name = role.role;
        this.myModel.display_name = role.role;
        this.myModel.previewBlock = false;
        this.myModel.type = 'role';
        this.myModel.belongsTo = parentRole !== '' ? 'Roles' : '';
        this.myModel.parentRole = parentRole;
        this.myModel.dbId = role.id;
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        const from = this.myModel.getElementId();
        if (parentRole !== '') {
            const roleModels = this.dataService.getModelsByName('Roles');
            const filtered_models = roleModels.filter((v, i) => v.type === parentRole);
            this.links.push({from: filtered_models[0].getElementId(), to: this.myModel.getElementId()});
        }


        this.myModel = new Model();
        this.myModel.name = 'Permission Groups';
        this.myModel.display_name = 'Permission Groups';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = role.role;
        this.myModel.belongsTo = role.role;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});


        this.myModel = new Model();
        this.myModel.name = 'Permissions';
        this.myModel.display_name = 'Permissions';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = role.role;
        this.myModel.belongsTo = role.role;
        // this.myModel.parentRole = roleName;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});

        this.myModel = new Model();
        this.myModel.name = 'Roles';
        this.myModel.display_name = 'Roles';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = role.role;
        this.myModel.belongsTo = role.role;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});


        this.myModel = new Model();
        this.myModel.name = 'Exclusions';
        this.myModel.display_name = 'Exclusions';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = role.role;
        this.myModel.belongsTo = role.role;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});


    }

    closeModelPreview() {
        this.previewPaneOpened = false;
        // drawer.toggle();
    }

    createPermissionBlock(permission, belongsTo = '') {
        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init();
            this.jsPlumbInitialized = true;
        }
        this.previewPaneOpened = true;
        this.modelPreview = new Model();
        this.modelPreview.name = permission;
        this.modelPreview.display_name = permission;
        this.modelPreview.use_soft_delete = false;
        this.modelPreview.previewBlock = true;
        this.modelPreview.type = 'permission';
        this.modelPreview.belongsTo = belongsTo;
        this.modelPreview.pos_x = 0;
        this.modelPreview.pos_y = 24;


        this.modelPreview.id = this.data.getNewModelId();
        // this.jsPlumbService.initModel(this.modelPreview);
        this.previewBlock = this.modelPreview;
    }

    createPermissionGroupBlock(permissionGroup, belongsTo = '') {
        this.previewPaneOpened = true;

        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init();
            this.jsPlumbInitialized = true;
        }
        this.modelPreview = new Model();
        this.modelPreview.name = permissionGroup.permissionGroup;
        this.modelPreview.display_name = permissionGroup.permissionGroup;
        this.modelPreview.use_soft_delete = false;
        this.modelPreview.previewBlock = true;
        this.modelPreview.type = 'permissionGroup';
        this.modelPreview.belongsTo = belongsTo;
        this.modelPreview.pos_x = 0;
        this.modelPreview.pos_y = 24;

        for (const permission of permissionGroup.permissions) {
            const schema = new Schema();
            schema.name = permission['permission'];
            schema.display_name = permission['permission'];
            schema.type = 'text';
            schema.input_type = 'text';
            this.modelPreview.schemas.push(schema);
        }

        this.previewBlock = this.modelPreview;
    }

    createSubRoles(role) {
        for (const cRole of role.roles) {
            if (cRole.role) {
                this.createRoleBlock(cRole, 0, 0, role.role);
                this.createdRoles.push(cRole.role);
                this.createSubRoles(cRole);
            }
        }
        // setTimeout(() => {
        //     // this.arrangeBlocks();
        //     this.tryArrangeBlocks(true);
        // }, 1000);

    }

    createExistingRole(role) {
        if (!this.createdRoles.includes(role.role)) {
            this.topLevelRoles.push(role.role);
            if (this.masterRole === '') {
                this.masterRole = role.role;
                this.createRoleBlock(role);
            } else {
                this.createRoleBlock(role, 0, 0, this.masterRole);
            }
            // this.masterRole = this.masterRole === '' ? role.role : this.masterRole;
            // this.createRoleBlock(role);
            this.createdRoles.push(role.role);
            this.createSubRoles(role);
            // for (const cRole of role.roles) {
            //     if (cRole.role) {
            //         this.createRoleBlock(cRole, 0, 0, role.role);
            //         this.createdRoles.push(cRole.role);
            //     }
            // }
            //
            // if (!this.isNewRoleCreated) {
            //     setTimeout(() => {
            //         // this.arrangeBlocks();
            //         this.tryArrangeBlocks(true);
            //     }, 1000);
            // }

            this.canvasOpenable = true;
        }

    }

    createRoleBlock(role, posX = 600, posY = 100, parentRole = '') {
        // this.models = [];
        this.createNewRole(role, posX, posY, parentRole);
        const permissionGroupModels = this.dataService.getModelsByName('Permission Groups');
        let filtered_models = permissionGroupModels.filter((v, i) => v.type === role.role);
        const permissionGroups_posX = filtered_models[0].pos_x;
        const permissionGroups_posY = filtered_models[0].pos_y;
        //let count = role.permission_groups.length / 2;
        for (const permissionGroup of role.permission_groups) {
            // this.createPermissionGroupBlock(permissionGroup, role.role);
            this.modelPreview = new Model();
            this.modelPreview.name = permissionGroup.permissionGroup;
            this.modelPreview.display_name = permissionGroup.display_name && permissionGroup.display_name !== '' ? permissionGroup.display_name : permissionGroup.permissionGroup;
            this.modelPreview.use_soft_delete = false;
            this.modelPreview.previewBlock = false;
            this.modelPreview.type = 'permissionGroup';
            this.modelPreview.belongsTo = 'Permission Groups';
            this.modelPreview.parentRole = role.role;
            this.modelPreview.dbId = permissionGroup.id;
            this.modelPreview.id = this.dataService.data.getNewModelId();
            //this.dataService.addModel(this.modelPreview);
            //this.models.push(this.modelPreview);
            //this.links.push({from: filtered_models[0].getElementId(), to: this.modelPreview.getElementId()});
            //count = count - 1;
            for (const permission of permissionGroup.permissions) {
                const schema = new Schema();
                schema.name = permission['permission'];
                schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
                schema.type = 'text';
                schema.input_type = 'text';
                schema.parent_id = this.modelPreview.id;
                schema.dbId = permission.id;
                schema.id = this.modelPreview.getNewSchemaId();
                this.modelPreview.schemas.push(schema);
                //this.dataService.addSchema(schema);

            }
            if (filtered_models.length) {
                filtered_models[filtered_models.length - 1].childModels.push(this.modelPreview);
            }

        }
        const permissionModels = this.dataService.getModelsByName('Permissions');
        filtered_models = permissionModels.filter((v, i) => v.type === role.role);
        const permission_posX = filtered_models[0].pos_x;
        const permission_posY = filtered_models[0].pos_y;
        //const permissionCount = role.permissions.length / 2;
        for (const permission of role.permissions) {
            const schema = new Schema();
            schema.name = permission.permission;
            schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
            schema.dbId = permission.id;
            schema.type = 'text';
            schema.input_type = 'text';
            schema.parent_id = filtered_models[filtered_models.length - 1].id;
            this.dataService.addSchema(schema);
        }

        const exclusionModels = this.dataService.getModelsByName('Exclusions');
        filtered_models = exclusionModels.filter((v, i) => v.type === role.role);
        for (const exclusion of role.exclusions) {
            const schema = new Schema();
            schema.name = exclusion.permission;
            schema.display_name = exclusion.display_name && exclusion.display_name !== '' ? exclusion.display_name : exclusion.permission;
            schema.dbId = exclusion.id;
            schema.type = 'text';
            schema.input_type = 'text';
            schema.parent_id = filtered_models[filtered_models.length - 1].id;
            if (filtered_models[filtered_models.length - 1].type === this.masterRole) {
                this.excludedPermissions.push(exclusion.permission);
            }
            this.dataService.addSchema(schema);
        }

        const roleModels = this.dataService.getModelsByName('Roles');
        filtered_models = roleModels.filter((v, i) => v.type === role.role);
        const role_posX = filtered_models[0].pos_x;
        const role_posY = filtered_models[0].pos_y;
        // let roleCount = role.roles.length / 2;
        // for (const currentRole of role.roles) {
        //     roleCount = roleCount - 1;
        //     this.createRoleBlock(currentRole, role_posX - (roleCount * 150), role_posY + 100, role.role);
        // }
    }


    tryArrangeBlocks(isNew) {
        const $container = $('.modelPane');
        const $diagram = $container.find('.diagram');
        const plumb = null;
        const that = this;
        const dg = new dagre.graphlib.Graph();
        dg.setGraph({nodesep: 30, ranksep: 50, marginx: 50, marginy: 50});
        dg.setDefaultEdgeLabel(function () {
            return {};
        });
        $container.find('.item').each(
            function (idx, node) {
                const $n = $(node);
                const box = {
                    width: Math.round($n.outerWidth()),
                    height: Math.round($n.outerHeight())
                };
                dg.setNode($n.attr('id'), box);
            }
        );

        // for (const model of that.models) {
        //     var $n = $(document.getElementById(model.getElementId()));
        //     var box = {
        //         width: Math.round($n.outerWidth()),
        //         height: Math.round($n.outerHeight())
        //
        //     };
        //     dg.setNode($n.attr('id'), box);
        // }

        // for (const model of that.data.models) {
        //     const targetIds = that.jsPlumbService.getAllConnections(model);
        //     if (targetIds.length) {
        //         for (const targetId of targetIds) {
        //             dg.setEdge(model.getElementH2Id(), targetId);
        //         }
        //
        //     }
        // }
        // for (const rRole of that.createdRoles) {
        //     console.log('loop');
        //     if (that.dataService.getModelByName(rRole.role).parentRole !== '') {
        //         console.log('if');
        //         const roleModels = that.dataService.getModelsByName('Roles');
        //         var filtered_models = roleModels.filter((v, i) => v.type === rRole.role);
        //         that.links.push({from: filtered_models[0].getElementId(), to: that.dataService.getModelByName(rRole.role).getElementId()});
        //         console.log('if');
        //     }
        //
        // }
        for (const link of that.links) {
            dg.setEdge(link.from, link.to);
        }

        // plumb.getAllConnections()
        //     .forEach(function (edge) {
        //         dg.setEdge(edge.source.id, edge.target.id);
        //     });
        dagre.layout(dg);
        const graphInfo = dg.graph();
        dg.nodes().forEach(
            function (n) {
                const node = dg.node(n);
                const top = Math.round(node.y - node.height / 2) + 'px';
                const left = Math.round(node.x - node.width / 2) + 'px';
                $('#' + n).css({left: left, top: top});
                // if (that.dataService.getModelByElementId(n)) {
                //     that.dataService.getModelByElementId(n).pos_x = Math.round(node.x - node.width / 2);
                //     that.dataService.getModelByElementId(n).pos_y = Math.round(node.y - node.height / 2);
                // }
                // that.jsPlumbService.repaintEverything();
                // that.models.filter((v, i) => {
                //     if (v.getElementId() === n) {
                //         v.pos_x = Math.round(node.x - node.width / 2);
                //         v.pos_y = Math.round(node.y - node.height / 2);
                //     }
                // });
            });
        if (isNew) {
            setTimeout(() => {
                for (const model of that.models) {
                    that.jsPlumbService.initModel(model);
                }
                this.models = [];
                // this.links = [];
            }, 1000);

        } else {
            setTimeout(() => {
                for (const link of that.links) {
                    // that.jsPlumbService.createConnection(that.dataService.getModelByElementId(link.from), that.dataService.getModelByElementId(link.to));
                }
                // that.jsPlumbService.toggleDraggable(that.dataService.getModelByElementId('model1'));
                // for (const model of that.models) {
                //     that.jsPlumbService.addToDragSelection(document.getElementById(model.getElementId()));
                //     that.dataService.getModelByElementId('model1').pos_x += 5;
                //     //that.dataService.getModelByElementId('model1').pos_y += 5;
                // }

            }, 3000);

        }
        // that.jsPlumbService.repaintEverything();
    }


    previewBlockDragStarted(event) {
        this.dragStarted = true;

        this.initialPosition = {
            x: document.getElementById('previewBlock').offsetLeft,
            y: document.getElementById('previewBlock').offsetTop
        };
        this.jsPlumbService.toggleDraggableDiv('previewBlock');
    }

    previewBlockDragStopped(model) {
        this.dragStarted = false;
        // this.jsPlumbService.toggleDraggableDiv('previewBlock');
        const element = document.getElementById('previewBlock');
        this.initialPosition.x = this.position.x;
        this.initialPosition.y = this.position.y;
    }

    mouseMoving(event) {
        if (this.dragStarted) {
            if (window.innerWidth - event.clientX + this.initialPosition.x < document.getElementById('previewBlock').offsetWidth) {
                this.position.x = window.innerWidth - document.getElementById('previewBlock').offsetWidth;
            }
            if (event.clientY > window.innerHeight - document.getElementById('previewBlock').offsetHeight + this.initialPosition.y) {
                this.position.y = window.innerHeight - document.getElementById('previewBlock').offsetHeight;
            }
            // draggable.style.left = cx + 'px';
            // draggable.style.top = cy + 'px';
            // let position = {x: event.clientX - this.initialPosition.x, y: event.clientY - this.initialPosition.y};
        }

    }

    droppedOnCanvas() {
    }

    dragEnded($event: CdkDragEnd) {

        // console.log(this.el.nativeElement.querySelectorAll('#' + 'previewBlock')[0].style.left);

    }

    onDragStopped(model) {
        //  jsPlumb.addToGroup('roleGroup', document.getElementById('model2'));
        //  jsPlumb.addToGroup('roleGroup', this.el.nativeElement.querySelectorAll('#model3')[0]);
        //  jsPlumb.addToGroup('roleGroup', this.el.nativeElement.querySelectorAll('#model4')[0]);
        // jsPlumb.collapseGroup('roleGroup');
        jsPlumb.hide(this.el.nativeElement.querySelectorAll('#' + model.getElementId())[0]);
        // console.log(document.getElementById('modelPreview'));
        if (model.previewBlock && model.pos_x >= document.getElementById('modelPreview').offsetLeft) {
            this.modelPreview.pos_x = model.pos_x - document.getElementById('modelPreview').offsetLeft;
            this.modelPreview.pos_y = model.pos_y;

            this.modelPreview.previewBlock = false;
            const newModel = new Model();
            newModel.name = this.modelPreview.name;
            newModel.display_name = this.modelPreview.display_name;
            newModel.use_soft_delete = false;
            newModel.previewBlock = false;
            newModel.type = model.type;
            newModel.pos_x = this.modelPreview.pos_x;
            newModel.pos_y = this.modelPreview.pos_y;
            this.dataService.addModel(newModel);


            for (const permission of this.modelPreview.schemas) {
                const schema = new Schema();
                schema.name = permission.name;
                schema.display_name = permission.name;
                schema.type = 'text';
                schema.input_type = 'text';
                const models = this.dataService.getModelsByName(newModel.name);
                schema.parent_id = models[models.length - 1].id;
                this.dataService.addSchema(schema);
            }
            this.previewPaneOpened = false;
            setTimeout(() => {
                this.jsPlumbService.initModel(newModel);
            }, 1000);

            // this.jsPlumbService.repaintEverything();

        } else if (model.belongsTo === '') {
            if (model.type === 'permissionGroup') {
                const permissionGroupModels = this.data.getModelsByName('Permission Groups');
                // for (const permissionGroupModel of permissionGroupModels) {
                if (permissionGroupModels.length) {
                    const permissionGroupModel = permissionGroupModels[0];
                    const permissionGroupBlock = document.getElementById(permissionGroupModel.getElementId());
                    const xStart = permissionGroupBlock.offsetLeft;
                    const xEnd = permissionGroupBlock.offsetLeft + permissionGroupBlock.offsetWidth;
                    const yStart = permissionGroupBlock.offsetTop;
                    const yEnd = permissionGroupBlock.offsetTop + permissionGroupBlock.offsetHeight;
                    if (((model.pos_x >= xStart) && (model.pos_x <= (xEnd))) && ((model.pos_y >= yStart) && (model.pos_y <= (yEnd)))) {
                        model.pos_x = xStart;
                        model.pos_y = yStart + 150;
                        model.type = 'permissionGroup';
                        model.belongsTo = 'Permission Groups';
                        model.parentRole = permissionGroupModel.type;
                        this.jsPlumbService.createConnection(permissionGroupModel, model);
                        this.links.push({from: permissionGroupModel.getElementId(), to: model.getElementId()});
                        this.tryArrangeBlocks(false);
                        setTimeout(() => {
                            for (const dmodel of this.models) {

                                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                            }
                            this.jsPlumbService.repaintEverything();
                        }, 1000);
                        // break;

                        // this.jsPlumbService.repaintEverything();
                    }
                }

                // }

            } else if (model.type === 'permission') {
                let permissionModels = [];
                permissionModels = this.data.getModelsByName('Permissions');
                permissionModels = permissionModels.concat(this.data.getModelsByType('permissionGroup'));
                for (const permissionModel of permissionModels) {
                    const permissionBlock = document.getElementById(permissionModel.getElementId());
                    const xStart = permissionBlock.offsetLeft;
                    const xEnd = permissionBlock.offsetLeft + permissionBlock.offsetWidth;
                    const yStart = permissionBlock.offsetTop;
                    const yEnd = permissionBlock.offsetTop + permissionBlock.offsetHeight;
                    if (((model.pos_x >= xStart) && (model.pos_x <= (xEnd))) && ((model.pos_y >= yStart) && (model.pos_y <= (yEnd)))) {
                        model.pos_x = xStart;
                        model.pos_y = yStart + 150;
                        model.belongsTo = 'Permissions';
                        const schema = new Schema();
                        schema.name = model.name;
                        schema.display_name = model.name;
                        schema.type = 'text';
                        schema.input_type = 'text';
                        schema.parent_id = permissionModel.id;
                        this.dataService.addSchema(schema);
                        this.dataService.deleteModel(model.id);
                        if (permissionModel.belongsTo !== '') {
                            this.tryArrangeBlocks(false);
                            setTimeout(() => {
                                for (const dmodel of this.models) {
                                    this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                                }
                                this.jsPlumbService.repaintEverything();
                            }, 1000);
                        }
                        break;
                    }
                }
            } else if (model.type === 'role') {
                const roleModels = this.data.getModelsByName('Roles');
                for (const roleModel of roleModels) {
                    const roleBlock = document.getElementById(roleModel.getElementId());
                    const xStart = roleBlock.offsetLeft;
                    const xEnd = roleBlock.offsetLeft + roleBlock.offsetWidth;
                    const yStart = roleBlock.offsetTop;
                    const yEnd = roleBlock.offsetTop + roleBlock.offsetHeight;
                    if (((model.pos_x >= xStart) && (model.pos_x <= (xEnd))) && ((model.pos_y >= yStart) && (model.pos_y <= (yEnd)))) {
                        model.pos_x = xStart;
                        model.pos_y = yStart + 150;
                        model.belongsTo = 'Roles';
                        this.jsPlumbService.createConnection(roleModel, model);
                        this.links.push({from: roleModel.getElementId(), to: model.getElementId()});
                        this.tryArrangeBlocks(false);
                        setTimeout(() => {
                            for (const dmodel of this.models) {
                                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                            }
                            this.jsPlumbService.repaintEverything();
                        }, 1000);
                    }
                }
            }

        }
    }


    setExcludedStyle(name, action) {
        const permissionGroups = this.dataService.getModelsByName('Permission Groups');
        if (permissionGroups) {
            for (const permissionGroup of permissionGroups) {
                if (permissionGroup.type !== 'Exclusions') {
                    for (const childModel of permissionGroup.childModels) {
                        if (childModel.name === name) {
                            const excludedDiv = document.getElementById(childModel.getElementH2Id());
                            if (excludedDiv && action === 'set') {
                                excludedDiv.style.backgroundColor = 'lightgray';
                                excludedDiv.style.color = 'black';
                                excludedDiv.style.fontWeight = 'bolder';
                                excludedDiv.style.textDecoration = 'line-through';
                                excludedDiv.style.opacity = '0.5';

                            } else if (excludedDiv && action === 'reset') {
                                excludedDiv.style.backgroundColor = '';
                                excludedDiv.style.color = 'white';
                                excludedDiv.style.fontWeight = '';
                                excludedDiv.style.textDecoration = 'none';
                                excludedDiv.style.opacity = '1';
                            }
                        }
                    }
                }
            }
        }
    }

    setPermissionExcludedStyle(name, action) {
        const permissionGroups = this.dataService.getModelsByName('Permission Groups');
        if (permissionGroups) {
            for (const permissionGroup of permissionGroups) {
                if (permissionGroup.type !== 'Exclusions') {
                    for (const childModel of permissionGroup.childModels) {
                        for (const exSchema of childModel.schemas) {
                            if (exSchema.name === name) {
                                if (action === 'set') {
                                    document.getElementById(exSchema.getElementId()).style.textDecoration = 'line-through';
                                } else {
                                    document.getElementById(exSchema.getElementId()).style.textDecoration = '';
                                }

                            }
                        }
                    }
                }
            }
        }
        const permissionBlocks = this.dataService.getModelsByName('Permissions');
        if (permissionBlocks) {
            for (const permissionBlock of permissionBlocks) {
                if (permissionBlock.type !== 'Exclusions') {
                    for (const exPermission of permissionBlock.schemas) {
                        if (exPermission.name === name) {
                            if (action === 'set') {
                                document.getElementById(exPermission.getElementId()).style.textDecoration = 'line-through';
                            } else {
                                document.getElementById(exPermission.getElementId()).style.textDecoration = '';
                            }
                        }
                    }
                }
            }
        }
    }

    deleteRole(model) {
        const conns = this.jsPlumbService.getAllConnections(model);
        this.createdRoles = this.createdRoles.filter((v, i) => v !== model.name);
        this.jsPlumbService.deleteModel(model);
        this.models = this.models.filter((v, i) => v.id !== model.id);
        this.links = this.links.filter((v, i) => v.to !== model.getElementId());
        for (const conn of conns) {
            const nextModel = this.dataService.getModelByElementH2Id(conn);
            if (nextModel) {
                this.jsPlumbService.addToDragSelection(document.getElementById(model.getElementId()));
                this.deleteRole(nextModel);
            }
        }
    }

    onDeletingModel(model) {
        if (model.type === 'role' && model.name === this.masterRole) {
            this.clearCanvas();
        } else if ((model.type === 'role' && model.name !== this.masterRole) || (model.name === 'Permission Groups')) {

            if (this.topLevelRoles.includes(model.name) || model.parentRole === 'Exclusions') {
                this.deleteRole(model);
            } else {
                const role = this.platformRoles.filter((v, i) => v.role === model.name);
                this.createRoleBlock(role[0], 0, 0, 'Exclusions');
                // this.masterRole = this.masterRole === '' ? role.role : this.masterRole;
                // this.createRoleBlock(role);
                this.createdRoles.push(role[0].role);
                this.createSubRoles(role[0]);
                setTimeout(() => {
                    // this.arrangeBlocks();
                    this.tryArrangeBlocks(true);
                }, 3000);
                // }
            }


            // model.type = '';
            // this.onDeletingModel(model);
        } else if (model.type === 'permissionGroup') {
            if (model.parentRole !== 'Exclusions') {
                if (model.parentRole === this.myRole) {
                    const dialogRef = this.dialog.open(DeletePermissionGroupDialogComponent, {
                        width: '250px',
                        data: {deleteAction: this.deleteAction, type: 'Permission Group'}
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        this.deleteAction = result;
                        if (this.deleteAction === 'removeFromRole') {
                            this.deletePermissionGroupFromRole(model);
                        } else if (this.deleteAction === 'excludePermissions') {
                            if (!this.userExcludedPermissionGroups.includes(model.name)) {
                                this.createExcludedPermissionGroup(model);
                            } else {
                                this.platform.openSnackBar(model.display_name + ' is already excluded', 'Error', {
                                    duration: 2000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        }
                    });
                } else {
                    if (!this.userExcludedPermissionGroups.includes(model.name)) {
                        const dialogRef = this.dialog.open(ConfirmExclusionsDialogComponent, {
                            width: '500px',
                            data: {type: 'Permission Group', action: 'add', name: model.display_name}
                        });
                        dialogRef.afterClosed().subscribe(result => {
                            if (result === 'yes') {
                                this.createExcludedPermissionGroup(model);
                            }
                        });
                    } else {
                        this.platform.openSnackBar(model.display_name + ' is already excluded', 'Error', {
                            duration: 2000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }

            } else if (model.parentRole === 'Exclusions') {
                const dialogRef = this.dialog.open(ConfirmExclusionsDialogComponent, {
                    width: '500px',
                    data: {type: 'Permission Group', action: 'remove', name: model.display_name}
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result === 'yes') {
                        this.deletePermissionGroupFromRole(model);
                    }
                });
            }
        } else if (model.type !== 'role') {
            this.jsPlumbService.deleteModel(model);
            this.models = this.models.filter((v, i) => v.id !== model.id);
            this.links = this.links.filter((v, i) => v.to !== model.getElementId());

            this.tryArrangeBlocks(false);
            setTimeout(() => {
                for (const dmodel of this.models) {
                    this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                }
                this.jsPlumbService.repaintEverything();
            }, 1000);
        }
    }

    createExcludedPermissionGroup(model) {
        const newModel = new Model();
        newModel.name = model.name;
        newModel.display_name = model.display_name;
        newModel.use_soft_delete = false;
        newModel.previewBlock = false;
        newModel.type = model.type;
        newModel.dbId = model.dbId;
        newModel.belongsTo = 'Permission Groups';
        newModel.parentRole = 'Exclusions';
        newModel.id = this.dataService.data.getNewModelId();
        //this.dataService.addModel(newModel);


        for (const permission of model.schemas) {
            const schema = new Schema();
            schema.name = permission.name;
            schema.display_name = permission.display_name;
            schema.type = 'text';
            schema.input_type = 'text';
            schema.parent_id = newModel.id;
            schema.id = newModel.getNewSchemaId();
            newModel.schemas.push(schema);
            //this.dataService.addSchema(schema);
        }
        this.userExcludedPermissionGroups.push(model.name);
        let filteredModels = this.dataService.getModelsByName('Permission Groups').filter((v, i) => v.type === 'Exclusions');
        filteredModels[0].childModels.push(newModel);
        this.setExcludedStyle(model.name, 'set');
        setTimeout(() => {
            this.tryArrangeBlocks(false);
            //setTimeout(() => {
            for (const dmodel of this.models) {
                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
            }
            this.jsPlumbService.repaintEverything();
            //}, 3000);
        }, 1000);
    }

    deletePermissionGroupFromRole(model) {
        this.userExcludedPermissionGroups = this.userExcludedPermissionGroups.filter((v, i) => v !== model.name);
        this.setExcludedStyle(model.name, 'reset');
        this.jsPlumbService.deleteModel(model);
        const permissionGroupModels = this.dataService.getModelsByName('Permission Groups');
        const permissionGroupModel = permissionGroupModels.filter((v, i) => v.type === model.parentRole)[0];
        permissionGroupModel.childModels = permissionGroupModel.childModels.filter((v, i) => v.id !== model.id);
        this.links = this.links.filter((v, i) => v.to !== model.getElementId());
        setTimeout(() => {
            for (const dmodel of this.models) {
                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
            }
            this.jsPlumbService.repaintEverything();
        }, 1000);
    }

    onDeletingPermission(permission) {
        const parentModel = this.dataService.getModelById(permission.parent_id);
        if (parentModel && parentModel.name === 'Permissions' && parentModel.type === 'Exclusions') {
            const dialogRef = this.dialog.open(ConfirmExclusionsDialogComponent, {
                width: '500px',
                data: {type: 'Permission', action: 'remove', name: permission.display_name}
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    const schema = new Schema();
                    schema.name = permission.name;
                    schema.display_name = permission.display_name;
                    schema.type = 'text';
                    schema.input_type = 'text';
                    // let filtered_models = this.dataService.getModelsByName(permissionGroup.permissionGroup).filter((v, i) => v.parentRole === role.role);
                    // schema.parent_id = filtered_models[0].id;
                    // const exec = exclusions.filter((v, i) => v.belongsTo === this.dataService.getModelById(permission.parent_id).parentRole);
                    schema.parent_id = permission.old_id;
                    const oldModel = this.dataService.getModelById(permission.old_id);
                    if (oldModel && oldModel.parentRole && oldModel.parentRole === this.masterRole) {
                        // this.dataService.addSchema(schema);
                    } else if (oldModel && oldModel.belongsTo === this.masterRole && oldModel.parentRole === '') {
                        // this.dataService.addSchema(schema);
                    }
                    this.setPermissionExcludedStyle(permission.name, 'reset');
                    this.dataService.deleteSchema(permission);
                    this.excludedPermissions = this.excludedPermissions.filter((v, i) => v !== permission.name);
                }
            });

        } else if (!this.excludedPermissions.includes(permission.name)) {
            if (parentModel && parentModel.name === 'Permissions' && parentModel.type === this.myRole) {
                const dialogRef = this.dialog.open(DeletePermissionGroupDialogComponent, {
                    width: '250px',
                    data: {deleteAction: this.deleteAction, type: 'Permission'}
                });
                dialogRef.afterClosed().subscribe(result => {
                    this.deleteAction = result;
                    if (this.deleteAction === 'removeFromRole') {
                        this.dataService.deleteSchema(permission);
                    } else if (this.deleteAction === 'excludePermissions') {
                        this.excludePermission(permission);
                    }
                });
            } else {
                const dialogRef = this.dialog.open(ConfirmExclusionsDialogComponent, {
                    width: '500px',
                    data: {type: 'Permission', action: 'add', name: permission.display_name}
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result === 'yes') {
                        this.excludePermission(permission);
                    }
                });
            }
        } else {
            this.platform.openSnackBar(permission.display_name + ' is already excluded', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        // this.tryArrangeBlocks(false);
        // setTimeout(() => {
        //     for (const dmodel of this.models) {
        //         this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
        //     }
        //     //this.jsPlumbService.repaintEverything();
        // }, 1000);
    }

    excludePermission(permission) {
        const schema = new Schema();
        schema.name = permission.name;
        schema.display_name = permission.display_name;
        schema.type = 'text';
        schema.input_type = 'text';
        let filtered_models = this.dataService.getModelsByName('Permissions').filter((v, i) => v.type === 'Exclusions');
        schema.parent_id = filtered_models[0].id;
        const exclusions = this.dataService.getModelsByName('Exclusions');
        // const exec = exclusions.filter((v, i) => v.belongsTo === this.dataService.getModelById(permission.parent_id).parentRole);
        schema.dbId = permission.dbId;
        schema['old_id'] = permission.parent_id;
        //schema.parent_id = exclusions[0].id;
        // this.modelPreview.schemas.push(schema);
        this.setPermissionExcludedStyle(permission.name, 'set');
        //document.getElementById(permission.getElementId()).style.backgroundColor = '#F34E4E';
        //document.getElementById(permission.getElementId()).style.opacity = '0.3';
        this.dataService.addSchema(schema);
        this.excludedPermissions.push(permission.name);
        // if (parentModel.parentRole === this.masterRole || (parentModel.parentRole === '' && parentModel.belongsTo === this.masterRole)) {
        //     // this.dataService.deleteSchema(permission);
        // }
    }

    getTrimmedName(role) {
        const trimmedName = role.split('=>');
        if (trimmedName && trimmedName.length) {
            return trimmedName[trimmedName.length - 1];
        }
    }

    clearCanvas() {
        this.models = [];
        this.links = [];
        this.excludedPermissions = [];
        this.createdRoles = [];
        this.masterRole = '';
        this.myRole = '';
        this.isNewRoleCreated = false;
        this.jsPlumbService.clearCanvas();

    }

    drop(ev) {
        ev.preventDefault();
        document.getElementById(this.highlightedModel.getElementId()).style.border = 'none';
        // for (const model of this.highlightedModels) {
        //     document.getElementById(model.getElementId()).style.border = 'none';
        // }
        // var data = ev.dataTransfer.getData("text");
        // ev.target.appendChild(document.getElementById(data));
    }

    allowDrop(ev) {
        ev.preventDefault();
    }

    drag(ev, type, entity) {
        // $('#drag').draggable();
        const temp = {
            type: type,
            entity: entity
        };
        let models = [];
        ev.dataTransfer.setData('data', JSON.stringify(temp));
        if (type === 'permissionGroup') {
            models = this.dataService.getModelsByName('Permission Groups');
            if (models.length) {
                this.highlightedModel = models.filter((v, i) => v.type === this.myRole)[0];
            }
        } else if (type === 'permission') {
            models = this.dataService.getModelsByName('Permissions');
            if (models.length) {
                this.highlightedModel = models.filter((v, i) => v.type === this.myRole)[0];
            }
        } else if (type === 'role') {
            this.highlightedModel = this.dataService.getModelByName('Roles');
        }
        document.getElementById(this.highlightedModel.getElementId()).style.border = '2px dashed green';

        // for (const model of this.highlightedModels) {
        //     document.getElementById(model.getElementId()).style.border = '2px dashed green';
        // }
    }


    attachPermissionGroup(connection) {
        const permissionGroup = connection.target;
        if (connection.source.type === this.myRole) {
            if (!connection.source.childModels.filter((v, i) => v.name === permissionGroup.permissionGroup).length) {
                const newModel = new Model();
                newModel.name = permissionGroup.permissionGroup;
                newModel.display_name = permissionGroup.display_name && permissionGroup.display_name !== '' ? permissionGroup.display_name : permissionGroup.permissionGroup;
                newModel.use_soft_delete = false;
                newModel.previewBlock = false;
                newModel.type = 'permissionGroup';
                newModel.belongsTo = 'Permission Groups';
                newModel.parentRole = connection.source.type;
                newModel.dbId = permissionGroup.id;
                newModel.id = this.dataService.data.getNewModelId();
                // newModel.pos_x = this.modelPreview.pos_x;
                // newModel.pos_y = this.modelPreview.pos_y;
                //this.dataService.addModel(newModel);


                for (const permission of permissionGroup.permissions) {
                    const schema = new Schema();
                    schema.name = permission.permission;
                    schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
                    schema.dbId = permission.id;
                    schema.type = 'text';
                    schema.input_type = 'text';
                    schema.parent_id = newModel.id;
                    schema.id = newModel.getNewSchemaId();
                    newModel.schemas.push(schema);
                    //this.dataService.addSchema(schema);
                }
                connection.source.childModels.push(newModel);
                setTimeout(() => {
                    this.tryArrangeBlocks(false);
                    //setTimeout(() => {
                    for (const dmodel of this.models) {
                        // if (dmodel.getElementId() !== this.dataService.getModelByName(this.masterRole).getElementId()) {
                        this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                        // }

                    }
                    //this.jsPlumbService.initModel(newModel);
                    this.jsPlumbService.repaintEverything();
                    //}, 3000);
                }, 1000);
            } else {
                this.platform.openSnackBar(permissionGroup.display_name + ' is already present', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }

        }
    }

    attachPermission(connection) {
        const permission = connection.target;
        if (connection.source.type === this.myRole) {
            if (!connection.source.schemas.filter((v, i) => v.name === permission.permission).length) {
                const schema = new Schema();
                schema.name = permission.permission;
                schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
                schema.dbId = permission.id;
                schema.type = 'text';
                schema.input_type = 'text';
                schema.parent_id = connection.source.id;
                this.dataService.addSchema(schema);
                // if (connection.source.belongsTo !== '') {
                //     this.tryArrangeBlocks(false);
                //     setTimeout(() => {
                //         for (const dmodel of this.models) {
                //             this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                //         }
                //         this.jsPlumbService.repaintEverything();
                //     }, 1000);
                // }
            } else {
                this.platform.openSnackBar(permission.display_name + ' is already present', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }
    }

    attachRole(connection) {
        const role = connection.target;
        if (!this.createdRoles.includes(role.role) && (connection.source.type === this.masterRole)) {
            this.models = [];
            this.createExistingRole(role);
            setTimeout(() => {
                // this.jsPlumbService.createConnection(connection.source, this.dataService.getModelByName(role.role));
                this.links.push({from: connection.source.getElementId(), to: this.dataService.getModelByName(role.role).getElementId()});
                this.tryArrangeBlocks(true);
                setTimeout(() => {
                    for (const dmodel of this.models) {
                        this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                    }
                    this.jsPlumbService.repaintEverything();
                }, 1000);
            }, 1000);
        }
    }

    saveRole() {
        const excludedPermissionGroups = [];
        const excludedPermissions = [];
        const excludedRoles = [];
        const originalRoles = [];

        const permissionGroups = this.dataService.getModelsByName('Permission Groups').filter((v, i) => v.type === 'Exclusions');
        const permissions = this.dataService.getModelsByName('Permissions').filter((v, i) => v.type === 'Exclusions');
        const roles = this.dataService.getModelsByType('role').filter((v, i) => v.parentRole === 'Exclusions');
        const selectedRoles = this.dataService.getModelsByType('role').filter((v, i) => v.parentRole === this.masterRole);
        const myRole = this.dataService.getModelByName(this.myRole);
        const myPermissionGroups = this.dataService.getModelsByName('Permission Groups').filter((v, i) => v.type === this.myRole);
        const myPermissions = this.dataService.getModelsByName('Permissions').filter((v, i) => v.type === this.myRole);
        const myExclusions = this.dataService.getModelsByName('Exclusions').filter((v, i) => v.type === this.myRole);
        // if (myRole) {
        //    this._service.pa
        // }
        const myRolePayload = {
            role: this.myRole,
            permission_groups: [],
            permissions: [],
            exclusions: [],
            partner: this.selectedEnvironment,
            account: this.selectedEnvironment,
            type: 'account'
        };
        for (const myPermissionGroup of myPermissionGroups[0].childModels) {
            myRolePayload.permission_groups.push(myPermissionGroup.dbId);
        }
        for (const myPermission of myPermissions[0].schemas) {
            myRolePayload.permissions.push(myPermission.dbId);
        }
        for (const myExclusion of myExclusions[0].schemas) {
            myRolePayload.exclusions.push(myExclusion.dbId);
        }


        this._service.patchItemUpdate(this.dbRoles[this.myRole], myRolePayload, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(response => {

        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while updating the role. Please try again after sometime.');
        });


        for (const permissionGroup of permissionGroups[0].childModels) {
            excludedPermissionGroups.push(permissionGroup.dbId);
        }

        for (const permission of permissions[0].schemas) {
            excludedPermissions.push(permission.dbId);
        }

        for (const role of roles) {
            excludedRoles.push(role.dbId);
        }

        for (const role of selectedRoles) {
            originalRoles.push(role.dbId);
        }
        // if (this.selectedUser.user_groups) {
        //     delete this.selectedUser.user_groups;
        // }
        for (let i = 0; i < this.selectedUser.environments.length; i++) {
            if (this.selectedUser.environments[i].name === this.selectedEnvironment) {
                this.selectedUser.environments[i].exclusions['permission_groups'] = excludedPermissionGroups;
                this.selectedUser.environments[i].exclusions['permissions'] = excludedPermissions;
                this.selectedUser.environments[i].exclusions['roles'] = excludedRoles;
                this.selectedUser.environments[i].roles = originalRoles;
                //this.selectedUser.environments[i]['account'] = this.selectedUser.environments[i].name;
                break;
            }
        }
        if (this.entityType === 'users') {
            this._service.patchItemUpdate(this.selectedUser.id, this.selectedUser, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(response => {
                this.platform.openSnackBar('User updated successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while updating the User. Please try again after sometime.');
            });
        } else if (this.entityType === 'userGroup') {
            this._service.patchItemUpdate(this.selectedUser.id, this.selectedUser, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(response => {
                this.platform.openSnackBar('User group updated successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while updating the User group. Please try again after sometime.');
            });
        }

        // const models = this.data.models.filter((v, i) => v.parentRole === this.masterRole);
        // const permissionGroups = [];
        // const permissions = [];
        // const roles = [];
        // const exclusions = [];
        // for (const model of models) {
        //     if (model.type === 'permissionGroup') {
        //         permissionGroups.push(model.dbId);
        //     } else if (model.type === 'role') {
        //         roles.push(this.dbRoles[model.name]);
        //     }
        // }
        // const permissionsList = this.dataService.getModelByName('Permissions');
        // for (const permission of permissionsList.schemas) {
        //     permissions.push(permission.dbId);
        // }
        // const exclusionsList = this.dataService.getModelByName('Exclusions');
        // for (const exclusion of exclusionsList.schemas) {
        //     exclusions.push(exclusion.dbId);
        // }
        // const payload = {
        //     'role': this.masterRole,
        //     'permission_groups': permissionGroups,
        //     'permissions': permissions,
        //     'roles': roles,
        //     'exclusions': exclusions,
        //     'partner': localStorage.getItem('partner'),
        //     'account': localStorage.getItem('account'),
        // };
        // if (this.isNewRoleCreated) {
        //     this._service.InsertRole(payload).subscribe(result => {
        //         this.platform.openSnackBar('Role saved successfully.', 'Success', {
        //             duration: 3000,
        //             verticalPosition: 'top',
        //             horizontalPosition: 'center'
        //         });
        //         this.loadRoles();
        //         this.clearCanvas();
        //     }, error => {
        //         this.platform.handleErrorGracefully(error, 'Error while saving the role. Please try again after sometime.');
        //     });
        // } else {
        //     this._service.UpdateRole(this.dbRoles[this.masterRole], payload).subscribe(result => {
        //         this.platform.openSnackBar('Role saved successfully.', 'Success', {
        //             duration: 3000,
        //             verticalPosition: 'top',
        //             horizontalPosition: 'center'
        //         });
        //         this.loadRoles();
        //         this.clearCanvas();
        //     }, error => {
        //         this.platform.handleErrorGracefully(error, 'Error while saving the role. Please try again after sometime.');
        //     });
        // }

    }

    layoutChanged() {
        const permissionGroupModels = this.dataService.getModelsByName('Permission Groups');
        const permissionModels = this.dataService.getModelsByName('Permissions');
        if (permissionGroupModels && permissionGroupModels.length) {
            for (const permissionGroupModel of permissionGroupModels) {
                let id = '#schema' + permissionGroupModel.getElementId();
                //$(permissionGroupModel.getElementId()).toggleClass('fa-chevron-up fa-chevron-down');;
                if ($(id).hasClass('in')) {
                    $(id).removeClass('in');
                }
                //$(id).hasClass('in') ? $(id).removeClass('in') : $(id).addClass('in');
                //document.getElementById(permissionGroupModel.getElementId()).style.display = 'none';
            }
        }
        if (permissionModels && permissionModels.length) {
            for (const permissionModel of permissionModels) {
                let id = '#schema' + permissionModel.getElementId();
                //$(permissionGroupModel.getElementId()).toggleClass('fa-chevron-up fa-chevron-down');;
                if ($(id).hasClass('in')) {
                    $(id).removeClass('in');
                }
                //document.getElementById(permissionModel.getElementId()).style.display = 'none';
            }
        }
        this.tryArrangeBlocks(false);
        setTimeout(() => {
            for (const dmodel of this.models) {

                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
            }
            this.jsPlumbService.repaintEverything();
        }, 1000);
    }

    save() {
        $('.content').addClass('shrink');
    }

    createRole() {
        $('.table-responsive').attr('class', 'table-responsive col-md-2');
        $('.visual-editor').show();
        this.operation = 'create';
        this.create = true;
        this.rightPanel = false;
    }

    cancel() {
        this.create = false;
        this.columns = this.columnCopy;
    }

    getId() {
        return (new Date().getTime()) * 1000 + Math.floor(Math.random() * 1001);
    }

    deleteRecord(id) {
        if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
            this._service.deleteRole(localStorage.getItem('partner'), localStorage.getItem('account'), id).subscribe(
                agents => {
                    this.platform.openSnackBar('Deleted successfully', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    const itemDuplicate = this.items;
                    const deleteditem = itemDuplicate.findIndex(p => p && p.id === id);
                    delete this.items[deleteditem];
                    //  this.removeItemFromUI(event);
                },
                error => {
                    this.platform.openSnackBar('Error while deleting this record: ' + error.error.message, 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            );
        } else {
        }
    }

    openUsersListDialog() {
        const dialogRef = this.dialog.open(UsersListDialogComponent, {
            height: '60%',
            width: '40%',
            data: {userGroupName: this.selectedUser.name, usersList: this.usersList}
        });

    }

}


@Component({
    selector: 'users-list-dialog',
    templateUrl: 'users-list-dialog.html',
    styleUrls: ['./user-management.component.css']
})

export class UsersListDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<UsersListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: UsersListData) {
    }

    searchText = '';
    settings = {text: 'Select attribute(s) to search instantly'};
    // itemList = [{id: 0, itemName: 'user'}, {id: 1, itemName: 'email'}];
    filterData = [{id: 0, itemName: 'user'}, {id: 1, itemName: 'email'}];

    // filterDataChanged() {
    //     console.log(this.filterData);
    // }

    closeDialog(): void {
        this.dialogRef.close();
    }
}

// @Component({
//   selector: 'delete-permission-group-dialog',
//   templateUrl: 'delete-permission-group-dialog.html',
//   styleUrls: ['./manage-roles.component.css']
// })
// export class DeletePermissionGroupDialogComponent {
//
//   constructor(
//       public dialogRef: MatDialogRef<DeletePermissionGroupDialogComponent>,
//       @Inject(MAT_DIALOG_DATA) public data: DialogData) {
//   }
//
//   onCancel(): void {
//     this.dialogRef.close();
//   }
//
// }
//
// @Component({
//   selector: 'new-role-group-dialog',
//   templateUrl: 'new-role-dialog.html',
//   styleUrls: ['./manage-roles.component.css']
// })
// export class NewRoleDialogComponent {
//
//   constructor(
//       public dialogRef: MatDialogRef<NewRoleDialogComponent>,
//       @Inject(MAT_DIALOG_DATA) public data: RoleDialogData) {
//   }
//
//   onCancel(): void {
//     this.dialogRef.close();
//   }
//
// }
